/* eslint-disable max-len */
import type { FC } from 'react';

import type { BreakPatternProps } from './breakPatternTypes';

export const Skirt3Break: FC<BreakPatternProps> = props => {
  const { topColor, bottomColor, shadowColor, shadowOpacity = 0.2, ...rest } = props;
  return (
    <svg
      width="1440"
      height="96"
      viewBox="0 0 1440 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      role="presentation"
      {...rest}
    >
      <defs>
        <filter id="break-skirt3-shadow" x="0" y="0" width="100%" height="96">
          <feGaussianBlur stdDeviation="15" />
          <feComposite operator="out" in2="SourceGraphic" />
        </filter>
      </defs>

      {/* Top section */}
      <path
        d="M0 0C34.849 14.3283 113.946 7.9634 169.366 14.5723C193.656 18.3155 229.541 28.3275 253.444 30.9529C320.056 36.6478 380.164 24.0008 446.021 28.8655C538.848 36.8216 612.91 60.1738 720.005 58.9539C827.081 60.1738 901.18 36.8253 993.979 28.8619C1059.84 23.9972 1119.94 36.6442 1186.56 30.9529C1210.32 28.3166 1246.29 18.3191 1270.63 14.5686C1326.17 7.96341 1405.17 14.3283 1440 0.00364149V0H0Z"
        fill={topColor}
      />

      {/* Bottom section */}
      <path
        d="M1440 96V0C1418.53 8.83496 1380.26 9.80273 1341.06 10.7939C1316.67 11.4102 1291.93 12.0361 1270.63 14.5684C1259.9 16.2227 1246.9 19.0908 1233.69 22.0078C1216.94 25.7051 1199.84 29.4795 1186.56 30.9531C1152.46 33.8662 1120.06 31.9736 1087.73 30.0859C1056.9 28.2852 1026.12 26.4873 993.979 28.8623C958.615 31.8965 925.967 37.165 893.176 42.457C839.916 51.0527 786.275 59.709 720.004 58.9541C653.738 59.709 600.121 51.0557 546.877 42.4639C514.072 37.1699 481.41 31.8984 446.021 28.8652C413.881 26.4912 383.107 28.2881 352.281 30.0879C319.943 31.9766 287.547 33.8682 253.443 30.9531C240.031 29.4795 222.848 25.6807 206.057 21.9688C192.922 19.0654 180.027 16.2148 169.367 14.5723C148.109 12.0371 123.369 11.4111 98.9785 10.7939C59.7793 9.80176 21.4824 8.83203 0 0V96H1440Z"
        fill={bottomColor}
      />

      {/* Drop shadow (same path as the top section with the filter applied) */}
      <path
        d="M0 0C34.849 14.3283 113.946 7.9634 169.366 14.5723C193.656 18.3155 229.541 28.3275 253.444 30.9529C320.056 36.6478 380.164 24.0008 446.021 28.8655C538.848 36.8216 612.91 60.1738 720.005 58.9539C827.081 60.1738 901.18 36.8253 993.979 28.8619C1059.84 23.9972 1119.94 36.6442 1186.56 30.9529C1210.32 28.3166 1246.29 18.3191 1270.63 14.5686C1326.17 7.96341 1405.17 14.3283 1440 0.00364149V0H0Z"
        fill={shadowColor}
        opacity={shadowOpacity}
        filter="url(#break-skirt3-shadow)"
      />
    </svg>
  );
};
